import { render } from "./VideoResources.vue?vue&type=template&id=75cccbea&scoped=true"
import script from "./VideoResources.vue?vue&type=script&lang=js"
export * from "./VideoResources.vue?vue&type=script&lang=js"

import "./VideoResources.vue?vue&type=style&index=0&id=75cccbea&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cccbea"]])

export default __exports__